import { Button, Form } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useContext, useEffect, useState } from "react";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { dictaminarActaHandler, generarPagoHandler } from "../../../handlers/accionActa.handler";
import { UserContext } from "../../../context";
import { Alert } from "@mui/material";

const ModalGenerarPago = ({ modals, handlerModal, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { loads } = useGeneralAppStore();
    const { actaDetalle } = useActaDetalleStore();

    //TODO API
    const { actions } = useContext(UserContext);

    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "modal_generar_pago" })
        }
    }, [])


    return (
        <Modal
            show={modals.includes('modal_generar_pago')}
            size={"md"}
            onHide={() => handlerModal({ modal: false, modalName: "modal_generar_pago" })}
            title={() => "Generar pago"}
        >

            <div className="d-flex flex-column gap-2 position-relative">
                {
                    loads.includes('gemerar_pago') &&
                    <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center " style={{ background: "rgba(255,255,255,0.8)", zIndex: "999" }}>
                        <MuniSpinner2 />
                    </div>

                }
                <Alert severity="primary">¿Desea generar el pago voluntario nuevamente?</Alert>
                <hr />
                <div className="d-flex justify-content-end gap-2">
                    {
                        actions?.hasPermission('dictamen.pagovoluntario.create') &&
                        <Button
                            variant="dark"
                            size="sm"
                            style={{ width: "fit-content" }}
                            onClick={() =>
                                generarPagoHandler({ id: actaDetalle.acta.dictamenes[0].id }, setRefetch)
                            }
                            disabled={loads.includes('gemerar_pago')}
                        >
                            {loads.includes('gemerar_pago')
                                ? "Guardando cambios..."
                                : "Generar pago"}
                        </Button>
                    }
                </div>
            </div>

        </Modal>
    );
}
export default ModalGenerarPago;